(function () {
  if (customElements.get('divano-cart-toast')) return;

  const ADD_SOURCES = new Set([
    'product-form-component',
    'divano-bundle',
    'divano-cart-bundle',
    'divano-cart-multibuy',
    'divano-comparison-cart',
  ]);

  const TOAST_HTML = `
    <div class="divano-cart-toast__inner" role="status" aria-live="polite">
      <span class="divano-cart-toast__check" aria-hidden="true">✓</span>
      <span class="divano-cart-toast__text">Added to cart</span>
      <a class="divano-cart-toast__link" id="DivanoCartToastLink" href="/cart">View cart</a>
    </div>
  `;

  function publish(action, cartCount) {
    try {
       (window).Shopify?.analytics?.publish?.('divano_atc_feedback', { action, cart_count: cartCount });
    } catch (e) {
    }
  }

  function bubbleCount() {
    const text = document.querySelector('#HeaderCartLink .cart-bubble__text-count')?.textContent || '';
    const n = parseInt(text.replace(/\D/g, ''), 10);
    return Number.isFinite(n) ? n : 0;
  }

  function testDrawer() {
    if ( (window).divanoCartUi?.arm !== 'drawer') return null;
    const drawer =  (document.querySelector('cart-drawer-component.divano-cart-ui__drawer'));
    return drawer && typeof drawer.open === 'function' ? drawer : null;
  }

  function openAfterQuickAdd(drawer) {
    const quickAdd = document.getElementById('quick-add-dialog');
    if (!quickAdd || !quickAdd.querySelector('dialog')?.open) {
      drawer.open();
      return;
    }
    let done = false;
    const go = () => {
      if (done) return;
      done = true;
      drawer.open();
    };
    quickAdd.addEventListener('dialog:close', () => requestAnimationFrame(go), { once: true });
    setTimeout(() => {
      if (!quickAdd.querySelector('dialog')?.open) go();
    }, 1500);
  }

  function shellShown(drawer) {
    return Boolean(drawer.querySelector('#cart-drawer-heading-empty'));
  }

  function whenFilled() {
    const ready =  (window).divanoCartUiDrawerReady || Promise.resolve();
    return Promise.race([ready, new Promise((resolve) => setTimeout(resolve, 1500))]).then(
      () => new Promise((resolve) => requestAnimationFrame(() => resolve(undefined)))
    );
  }

  let bagPending = false;

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('#HeaderCartLink')) return;
    publish('bag_tap', bubbleCount());
    if (event.defaultPrevented || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const drawer = testDrawer();
    if (!drawer) return;
    event.preventDefault();
    if (bagPending) return;
    bagPending = true;
    const href =  (event.target.closest('#HeaderCartLink')).href;
    whenFilled().then(() => {
      bagPending = false;
      if (bubbleCount() > 0 && shellShown(drawer)) {
        window.location.assign(href);
        return;
      }
      drawer.open();
    });
  });

  function cartRoute() {
    return (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_url) || '/cart';
  }

  function isCartPage(cartUrl) {
    const trim = (path) => path.replace(/\/+$/, '') || '/';
    return trim(window.location.pathname) === trim(new URL(cartUrl, window.location.origin).pathname);
  }

  class DivanoCartToast extends HTMLElement {
    connectedCallback() {
      this.innerHTML = TOAST_HTML;
      const link = this.querySelector('.divano-cart-toast__link');
      if (link) {
        const cartUrl = cartRoute();
        link.setAttribute('href', cartUrl);
        link.hidden = isCartPage(cartUrl);
        link.addEventListener('click', () => publish('toast_tap', bubbleCount()));
      }
      this._timer = null;
      this._onUpdate = this._onUpdate.bind(this);
      document.addEventListener('cart:update', this._onUpdate);
    }

    disconnectedCallback() {
      document.removeEventListener('cart:update', this._onUpdate);
      if (this._timer) clearTimeout(this._timer);
    }

    _onUpdate(event) {
      if (event && event.detail && event.detail.data && event.detail.data.didError) return;
      const detail = (event && event.detail) || {};
      const source = (detail.data && detail.data.source) || detail.source;
      if (!ADD_SOURCES.has(source)) return;
      const count = detail.resource && detail.resource.item_count;
      const cartCount = Number.isFinite(count) ? count : bubbleCount();
      const drawer = testDrawer();
      if (drawer) {
        if (drawer.querySelector('dialog')?.open) return;
        const open = () => {
          openAfterQuickAdd(drawer);
          publish('drawer_open', cartCount);
        };
        if (cartCount > 0 && shellShown(drawer)) {
          whenFilled().then(() => (shellShown(drawer) ? this._showToast(cartCount) : open()));
          return;
        }
        open();
        return;
      }
      this._showToast(cartCount);
    }

    _showToast(cartCount) {
      this.classList.add('divano-cart-toast--visible');
      publish('toast_shown', cartCount);
      if (this._timer) clearTimeout(this._timer);
      this._timer = setTimeout(() => {
        this.classList.remove('divano-cart-toast--visible');
      }, 2500);
    }
  }

  customElements.define('divano-cart-toast', DivanoCartToast);

  function inject() {
    if (document.querySelector('divano-cart-toast')) return;
    const el = document.createElement('divano-cart-toast');
    el.className = 'divano-cart-toast';
    el.id = 'DivanoCartToast';
    document.body.appendChild(el);
  }

  function injectStyles() {
    if (document.getElementById('divano-cart-toast-styles')) return;
    const s = document.createElement('style');
    s.id = 'divano-cart-toast-styles';
    s.textContent = `
      .divano-cart-toast {
        position: fixed;
        inset-block-end: 24px;
        inset-inline-end: 24px;
        z-index: 9999;
        max-width: calc(100vw - 48px);
        opacity: 0;
        transform: translateY(8px);
        transition: opacity 0.18s ease-out, transform 0.18s ease-out;
        pointer-events: none;
      }
      .divano-cart-toast--visible { opacity: 1; transform: translateY(0); pointer-events: auto; }
      .divano-cart-toast__inner {
        display: inline-flex; align-items: center; gap: 12px;
        padding: 12px 20px;
        background: oklch(0.20 0.01 30);
        color: oklch(0.99 0.003 30);
        font-family: var(--font-body--family, 'Manrope', system-ui, sans-serif);
        font-size: 0.875rem;
        border-radius: 4px;
        box-shadow: 0 6px 20px rgb(0 0 0 / 0.15);
      }
      .divano-cart-toast__check {
        display: inline-flex; align-items: center; justify-content: center;
        width: 18px; height: 18px;
        background: oklch(0.65 0.18 145);
        color: oklch(0.99 0.003 30);
        border-radius: 50%;
        font-size: 0.6875rem;
        font-weight: 700;
      }
      .divano-cart-toast__link {
        color: oklch(0.99 0.003 30);
        text-decoration: underline;
        text-underline-offset: 2px;
      }
      @media (max-width: 480px) {
        .divano-cart-toast {
          inset-block-end: 16px;
          inset-inline-end: 16px;
          inset-inline-start: 16px;
          max-width: calc(100vw - 32px);
        }
        .divano-cart-toast__inner { width: 100%; justify-content: space-between; }
      }
    `;
    document.head.appendChild(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { injectStyles(); inject(); });
  } else {
    injectStyles();
    inject();
  }
})();
